module.exports = "<div class=\"header\"><h1><a [routerLink]=\"['/']\">Æffect App</a></h1></div>\n"